<template>
  <b-row class="terms-conditions no-gutters">
    <b-col class="tool-border" cols="12">
    <b-col class="reduce-padding"  cols="12">
      <wlpHeader :pageTitle="pageTitle"></wlpHeader>
    </b-col>
  
   <b-col class="page-background-gradient reduce-padding" cols="12">
      <b-row class="page-content-singles  no-gutters">
        <b-row class = "body-sec no-gutters">
          <b-row class = "scroll no-gutters">
             <b-col :class="{'max-width-sp' : $i18n.locale=='sp', 'max-width': $i18n.locale=='en'}" cols="12">
              <b-row class ="no-gutters">
                <b-col class="reduce-padding">
                  <div class="section-heading extra-top-padding">{{$t('terms.h1')}}</div>
                  <p class="pg1"> {{$t('terms.text1')}} </p>
                  <br>  
                  <div class="section-heading">{{$t('terms.h2')}}</div> 
                  <p class="pg1"> {{$t('terms.text2-1')}}<br>{{$t('terms.text2-2')}}
                  </p>
                  <br>
                  <div  class="section-heading">{{$t('terms.h3')}} </div>
                  <p class="pg1-2"> {{$t('terms.text3')}} </p><br>

                  <div id="htn" class="section-heading">{{$t('terms.h4')}}</div>
                  <p :class="{'padding-5' : $i18n.locale=='sp'}" > {{$t('terms.text4')}}</p>

                  <br>
                  <div id="oa" class="section-heading">{{$t('terms.h5')}}</div>
                  <p> {{$t('terms.text5')}} </p>

                  <br>
                  <div id="sleep" class="section-heading"> {{$t('terms.h6')}} </div>
                  <p> {{$t('terms.text6')}}</p>
                  <br>

                  <div id="dbt" class="section-heading"> {{$t('terms.h7')}} </div>

                  <p class="privacy-text"> {{$t('terms.text7-1')}} <span class="double-spacing"></span>{{$t('terms.text7-2')}}
                  </p>
                  <br>
                  <div id="summary" class="section-heading"> {{$t('terms.h8')}}</div>
          
                  <p> {{$t('terms.text8')}} </p>
                  <br>
                  <div id="goals" class="section-heading">{{$t('terms.h9')}}</div>
                  <p class="dispute-sec"> {{$t('terms.text9-1')}} </p>
                  <p class="dispute-sec"> {{$t('terms.text9-2')}}</p>
                  <p class="dispute-sec">  {{$t('terms.text9-3')}}</p>
                  <p class="dispute-text dispute-sec"> {{$t('terms.text9-4')}}</p>
                  <br>
                  <div class="section-heading">{{$t('terms.h10')}}</div>
                  <p class="as-is-text" >  {{$t('terms.text10')}}  </p>
                  <br>
                  <div class="section-heading">{{$t('terms.h11')}}</div>
                  <p class="as-is-text">  {{$t('terms.text11')}} </p>
                  <br>
          
                  <div class="section-heading">{{$t('terms.h12')}}</div>
                  <p class="indemnity-width">  {{$t('terms.text12')}}</p>
          
                  <br>
                  <div class="section-heading">{{$t('terms.h13')}}</div>
                  <p> {{$t('terms.text13')}}</p>
          
                  <br>
                  <div class="section-heading">{{$t('terms.h14')}}</div>
                  <p> {{$t('terms.text14')}}</p>
          
                  <br>
                  <div class="section-heading">{{$t('terms.h15')}}</div>
                  <p class="as-is-width"> {{$t('terms.text15')}}</p>
          
                  <br>
                  <div class="section-heading">{{$t('terms.h16')}}</div>
                  <p> {{$t('terms.text16')}}</p>
          
                  <br>
                  <div class="section-heading">{{$t('terms.h17')}}</div>
                  <p> {{$t('terms.text17')}}</p>
          
                  <br>
                  <div class="section-heading">{{$t('terms.h18')}}</div>
                  <p :class="{'void-text' : $i18n.locale=='en'}" > {{$t('terms.text18')}} </p>
          
                  <br>
                  <div class="section-heading">{{$t('terms.h19')}}</div>
                  <p class="audience-text"> {{$t('terms.text19-1')}}</p>
                  <p class="second-para"> {{$t('terms.text19-2')}}</p>

                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-row>
      </b-row>
      
      <wlpNavigation :navButtons="['previous','menu2']" :currentScreen="1"></wlpNavigation>
    </b-col>
  </b-col>
  </b-row>
</template>
<script>
import scrollMixin from "../mixins/scrollMixin";
import wlpNavigation from '../components/wlpNavigation.vue';
  import wlpHeader from '../components/wlpHeader.vue';

export default {
  name: "termsConditions",
  mixins: [scrollMixin],
  mounted: function () {
    this.scrollToTop();
  },
  components: {
    'wlpNavigation': wlpNavigation,
    'wlpHeader': wlpHeader,
  },

  data() {
    return {
      pageTitle: this.$t('terms.pageTitle'),

    };
  },
};
</script>


<style lang="scss" scoped>
</style>
